<ng-container *ngIf="addressForm" [formGroup]="addressForm">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Property Location</ion-card-title>
      <div *ngIf="!siteComplete.directionsCompleted(addressForm.value)" class="required-pill ion-float-end">
        <p class="paragraph">required</p>
      </div>
      <curbnturf-checked *ngIf="siteComplete.directionsCompleted(addressForm.value)"> </curbnturf-checked>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
      <div class="form-wrapper">
        <div class="title-information-wrapper">
          <h4>Does your property have an address?</h4>
        </div>
        <div class="title">Verified CurbNTurfers who have a confirmed bookings need to know where to go.</div>
        <curbnturf-location
          #locationComponent
          [addressForm]="address"
          [coordinatesForm]="coordinates"
          [coordinatesShow]="true"
        >
        </curbnturf-location>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Landowner</ion-card-title>
      <div *ngIf="!landOwnerCompleted(addressForm.value)" class="required-pill ion-float-end">
        <p class="paragraph">required</p>
      </div>
      <curbnturf-checked *ngIf="landOwnerCompleted(addressForm.value)"></curbnturf-checked>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
      <div class="form-wrapper">
        <curbnturf-land-owner #landOwnerComponent [landOwner]="landOwner" [boondocking]="!!boondock" [editView]="true">
        </curbnturf-land-owner>

        <ng-container *ngIf="boondock?.id">
          <h4>
            Public Land Owner Contact Information
            <small> (This will be publicly displayed) </small>
          </h4>
          <label for="boondocking-phone"> Phone </label>
          <input id="boondocking-phone" [formControl]="phone" class="text-input w-input" cntMaskPhone />
          <label for="boondocking-email"> Email </label>
          <input id="boondocking-email" [formControl]="email" class="text-input w-input" />
          <label for="boondocking-website"> Website </label>
          <input id="boondocking-website" [formControl]="url" class="text-input w-input" />
        </ng-container>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>RV Requirements</ion-card-title>
      <curbnturf-checked></curbnturf-checked>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
      <div class="form-wrapper">
        <curbnturf-rv-requirements [accessRoute]="accessRoute"> </curbnturf-rv-requirements>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Arrival Instructions For Your Property</ion-card-title>
      <div class="optional-rift-soft">Optional</div>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
      <div class="form-wrapper">
        <p>
          <label for="instructions">
            Okay, you&rsquo;ve got the CurbNTurfer to your property. Do you have any instructions to get them to the
            site?
          </label>
        </p>
        <textarea
          [formControl]="directions"
          placeholder="Example: When you get through the gate, take your first right onto the dirt road.  You can park in the designated spot that has been marked out about 300 yards down the road..."
          id="instructions"
          name="instructions"
          class="site-description w-input"
        ></textarea>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Detailed Directions to Site</ion-card-title>
      <div class="optional-rift-soft">Optional</div>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
      <div class="form-wrapper">
        <p>
          Fill out this section to give a more detailed coordinate based direction to your property. This is especially
          important when your property requires detailed directions from the nearest road.
        </p>
        <h4>What is the starting GPS coordinates?</h4>
        <p class="fine-print">We recommend the nearest interstate or highway exit.</p>
        <div [formGroup]="startingPoint" class="button-wrapper-grid">
          <div (click)="setCoordinatesToCurrent()" class="cnt-button">
            <div class="cnt-button-copy">Use my Current Location</div>
          </div>
          <div (click)="getCoordinatesFromMap()" class="cnt-button">
            <div class="cnt-button-copy">Find on Map</div>
          </div>
          <div class="left-column-wrapper">
            <div class="title-2up"><label for="lat-sp">Latitude</label></div>
            <input
              class="l-lat-text-field w-input"
              id="lat-sp"
              name="lat"
              type="number"
              min="-90"
              max="90"
              step="0.000001"
              formControlName="lat"
            />
          </div>
          <div class="right-column-wrapper">
            <div class="title-2up"><label for="lon-sp">Longitude</label></div>
            <input
              class="l-lat-text-field w-input"
              id="lon-sp"
              name="lon"
              type="number"
              min="-180"
              max="180"
              step="0.000001"
              formControlName="lon"
            />
          </div>
        </div>
        <div class="divider-line"></div>
        <curbnturf-add-waypoint [waypoints]="intermediateWaypoints" [startingPoint]="startingPoint">
        </curbnturf-add-waypoint>
      </div>
    </ion-card-content>
  </ion-card>
</ng-container>
